<template>
  <tableau-view v-if="url" :url="url"></tableau-view>
</template>
<script>

import TableauView from '@/components/tb_view';

export default {
  components: {
    TableauView
  },
  data () {
    return {
      url: '',
    }
  },
  mounted() {

    let mainApp = this.$store.state.apps[0];
    let appId   = mainApp.id;

    this.getApp(appId);

  },
  methods: {
    async getApp(appId) {
      let rst = await this.$http.get(`/etp/v1.0/app/detail?id=${appId}`);
      let app = rst.data.data;
      this.url = app.tb_share_link;
    }
  }
}
</script>
<style lang='less' scoped>
.container {
  padding: 20px;
}
</style>
